import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { protectSheetWithRandomPassword } from './ExcelUtils';

export async function exportExcelBranchWise({
                                      apiData,
                                      fileName = "District And Branch Deposits Branch Wise Excel.xlsx",
                                        loginPlaceId
                                  }) {
    try {
        const workbook = new ExcelJS.Workbook();
        workbook.creator = 'MIS System';
        workbook.lastModifiedBy = 'MIS Reporting tool';
        workbook.created = new Date();
        workbook.modified = new Date();
        workbook.properties = { date1904: false };
        workbook.calcProperties.fullCalcOnLoad = true;

        const sheet = workbook.addWorksheet("Report", {
            views: [{
                state: 'frozen',
                xSplit: 2,
                ySplit: 4,
                topLeftCell: 'C5',
                activeCell: 'C5'
            }]
        });

        const baseColumns = [
            { key: 'product', width: 30 },
            { key: 'description', width: 15 }
        ];

        const branchColumnsTemplate = [
            { key: 'activeAccount', width: 12 },
            { key: 'activeAmount', width: 15, style: { numFmt: '#,##0.00' }},
            { key: 'dormantAccount', width: 12 },
            { key: 'dormantAmount', width: 15, style: { numFmt: '#,##0.00' }},
            { key: 'totalAccount', width: 12 },
            { key: 'percentage', width: 12, style: { numFmt: '0.00%' }},
            { key: 'totalAmount', width: 15, style: { numFmt: '#,##0.00' }},
            { key: 'amountPercentage', width: 12, style: { numFmt: '0.00%' }}
        ];

        const allColumns = [...baseColumns];
        apiData.forEach((_, index) => {
            branchColumnsTemplate.forEach(col => {
                allColumns.push({
                    ...col,
                    key: `${col.key}_${index}`
                });
            });
        });
        sheet.columns = allColumns;

        apiData.forEach((branch, branchIndex) => {
            const startCol = 3 + (branchIndex * 8);

            sheet.getRow(1).getCell(startCol).value = branch.branchName;
            sheet.mergeCells(1, startCol, 1, startCol + 7);

            sheet.getRow(2).getCell(startCol).value = "Active";
            sheet.mergeCells(2, startCol, 2, startCol + 1);
            sheet.getRow(2).getCell(startCol + 2).value = "Dormant";
            sheet.mergeCells(2, startCol + 2, 2, startCol + 3);
            sheet.getRow(2).getCell(startCol + 4).value = "Total";
            sheet.getRow(2).getCell(startCol + 5).value = "Percentage";
            sheet.getRow(2).getCell(startCol + 6).value = "Total Amount";
            sheet.getRow(2).getCell(startCol + 7).value = "Percentage";

            sheet.getRow(3).getCell(startCol).value = "Account";
            sheet.getRow(3).getCell(startCol + 1).value = "Amount";
            sheet.getRow(3).getCell(startCol + 2).value = "Account";
            sheet.getRow(3).getCell(startCol + 3).value = "Amount";
            sheet.getRow(3).getCell(startCol + 4).value = "Account";
            sheet.getRow(3).getCell(startCol + 5).value = "(5/7)";
            sheet.getRow(3).getCell(startCol + 6).value = "";
            sheet.getRow(3).getCell(startCol + 7).value = "(6/9)";

            sheet.getRow(4).getCell(startCol).value = "3";
            sheet.getRow(4).getCell(startCol + 1).value = "4";
            sheet.getRow(4).getCell(startCol + 2).value = "5";
            sheet.getRow(4).getCell(startCol + 3).value = "6";
            sheet.getRow(4).getCell(startCol + 4).value = "7";
            sheet.getRow(4).getCell(startCol + 5).value = "8";
            sheet.getRow(4).getCell(startCol + 6).value = "9";
            sheet.getRow(4).getCell(startCol + 7).value = "10";
        });

        sheet.getRow(3).getCell(1).value = "Product Name";
        sheet.getRow(3).getCell(2).value = "Description";
        sheet.getRow(4).getCell(1).value = "1";
        sheet.getRow(4).getCell(2).value = "2";

        const grayHeaderStyle = {
            fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } },
            font: { bold: true, color: { argb: 'FF000000' }, name: 'Calibri', size: 11 },
            alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
            border: {
                top: { style: 'thin', color: { argb: 'FF000000' } },
                left: { style: 'thin', color: { argb: 'FF000000' } },
                bottom: { style: 'thin', color: { argb: 'FF000000' } },
                right: { style: 'thin', color: { argb: 'FF000000' } }
            }
        };

        const numberHeaderStyle = {
            ...grayHeaderStyle,
            font: { ...grayHeaderStyle.font, color: { argb: 'FF0000FF' } }
        };

        for (let rowNum = 1; rowNum <= 4; rowNum++) {
            const row = sheet.getRow(rowNum);
            row.eachCell(cell => {
                Object.assign(cell.style, rowNum === 4 ? numberHeaderStyle : grayHeaderStyle);
            });

            apiData.forEach((_, branchIndex) => {
                const lastCol = 3 + (branchIndex * 8) + 7;
                const cell = row.getCell(lastCol);

                cell.border = {
                    ...cell.border,
                    right: { style: 'thin', color: { argb: 'FFFF0000' } }
                };
            });
        }

        const allProducts = new Set();
        apiData.forEach(branch => {
            ['ShareAndMember', 'OtherAccounts', 'NonDormantAccounts'].forEach(type => {
                branch.data[type]?.forEach(item => {
                    if (item?.productName) {
                        allProducts.add(item.productName.trim());
                    }
                });
            });
        });

        let currentRow = 5;
        const dataRows = [];
        const subtotalRows = [];

        Array.from(allProducts).forEach(productName => {
            const hasGenderData = apiData.some(branch =>
                branch.data.ShareAndMember?.some(item => item?.productName?.trim() === productName)
            );

            if (hasGenderData) {
                const femaleRow = new Array(allColumns.length).fill('');
                femaleRow[0] = productName;
                femaleRow[1] = 'Female';

                apiData.forEach((branch, branchIndex) => {
                    const item = branch.data.ShareAndMember?.find(i => i?.productName?.trim() === productName);
                    if (item) {
                        const colOffset = 2 + (branchIndex * 8);
                        femaleRow[colOffset] = item.femaleActiveCount;
                        femaleRow[colOffset + 1] = item.femaleActiveAmount;
                        femaleRow[colOffset + 2] = item.femaleDormantCount;
                        femaleRow[colOffset + 3] = item.femaleDormantAmount;
                        femaleRow[colOffset + 4] = {
                            formula: `${getCol(colOffset)}${currentRow}+${getCol(colOffset + 2)}${currentRow}`
                        };
                        femaleRow[colOffset + 5] = {
                            formula: `${getCol(colOffset + 2)}${currentRow}/${getCol(colOffset + 4)}${currentRow}`,
                            style: { numFmt: '0.00%' }
                        };
                        femaleRow[colOffset + 6] = {
                            formula: `${getCol(colOffset + 1)}${currentRow}+${getCol(colOffset + 3)}${currentRow}`
                        };
                        femaleRow[colOffset + 7] = {
                            formula: `${getCol(colOffset + 3)}${currentRow}/${getCol(colOffset + 6)}${currentRow}`,
                            style: { numFmt: '0.00%' }
                        };
                    }
                });

                const addedFemaleRow = sheet.addRow(femaleRow);
                dataRows.push(currentRow);
                rBorder(addedFemaleRow, apiData.length);
                currentRow++;

                const maleRow = new Array(allColumns.length).fill('');
                maleRow[1] = 'Male';

                apiData.forEach((branch, branchIndex) => {
                    const item = branch.data.ShareAndMember?.find(i => i?.productName?.trim() === productName);
                    if (item) {
                        const colOffset = 2 + (branchIndex * 8);
                        maleRow[colOffset] = item.maleActiveCount;
                        maleRow[colOffset + 1] = item.maleActiveAmount;
                        maleRow[colOffset + 2] = item.maleDormantCount;
                        maleRow[colOffset + 3] = item.maleDormantAmount;
                        maleRow[colOffset + 4] = {
                            formula: `${getCol(colOffset)}${currentRow}+${getCol(colOffset + 2)}${currentRow}`
                        };
                        maleRow[colOffset + 5] = {
                            formula: `${getCol(colOffset + 2)}${currentRow}/${getCol(colOffset + 4)}${currentRow}`,
                            style: { numFmt: '0.00%' }
                        };
                        maleRow[colOffset + 6] = {
                            formula: `${getCol(colOffset + 1)}${currentRow}+${getCol(colOffset + 3)}${currentRow}`
                        };
                        maleRow[colOffset + 7] = {
                            formula: `${getCol(colOffset + 3)}${currentRow}/${getCol(colOffset + 6)}${currentRow}`,
                            style: { numFmt: '0.00%' }
                        };
                    }
                });

                const addedMaleRow = sheet.addRow(maleRow);
                dataRows.push(currentRow);
                rBorder(addedMaleRow, apiData.length);
                currentRow++;

                const subtotalRow = tRow(sheet, currentRow - 2, currentRow - 1, "Total", "B", apiData.length);
                subtotalRows.push(subtotalRow);
                currentRow++;

                SRow(sheet, currentRow, allColumns.length, apiData.length);
                currentRow++;
            }
            else {
                const dataRow = new Array(allColumns.length).fill('');
                dataRow[0] = productName;

                apiData.forEach((branch, branchIndex) => {
                    const colOffset = 2 + (branchIndex * 8);

                    let item = branch.data.OtherAccounts?.find(i => i?.productName?.trim() === productName);
                    let isNonDormant = false;

                    if (!item) {
                        item = branch.data.NonDormantAccounts?.find(i => i?.productName?.trim() === productName);
                        isNonDormant = true;
                    }

                    if (item) {
                        dataRow[colOffset] = isNonDormant ? item.count : item.activeCount;
                        dataRow[colOffset + 1] = isNonDormant ? item.totalAmount : item.activeAmount;
                        dataRow[colOffset + 2] = isNonDormant ? 0 : item.dormantCount;
                        dataRow[colOffset + 3] = isNonDormant ? 0 : item.dormantAmount;
                        dataRow[colOffset + 4] = {
                            formula: `${getCol(colOffset)}${currentRow}+${getCol(colOffset + 2)}${currentRow}`
                        };
                        dataRow[colOffset + 5] = {
                            formula: `${getCol(colOffset + 2)}${currentRow}/${getCol(colOffset + 4)}${currentRow}`,
                            style: { numFmt: '0.00%' }
                        };
                        dataRow[colOffset + 6] = {
                            formula: `${getCol(colOffset + 1)}${currentRow}+${getCol(colOffset + 3)}${currentRow}`
                        };
                        dataRow[colOffset + 7] = {
                            formula: `${getCol(colOffset + 3)}${currentRow}/${getCol(colOffset + 6)}${currentRow}`,
                            style: { numFmt: '0.00%' }
                        };
                    }
                });

                const dataSetRow = sheet.addRow(dataRow);
                sheet.mergeCells(`A${currentRow}:B${currentRow}`);
                dataRows.push(currentRow);
                rBorder(dataSetRow, apiData.length);
                currentRow++;

                SRow(sheet, currentRow, allColumns.length, apiData.length);
                currentRow++;
            }
        });

        if (dataRows.length > 0) {
            const rowsToInclude = dataRows.filter(row => !subtotalRows.includes(row));

            if (rowsToInclude.length > 0) {
                const firstDataRow = Math.min(...rowsToInclude);
                const lastDataRow = Math.max(...rowsToInclude);

                const totalsRow = [];
                totalsRow[0] = "FULL TOTAL";
                totalsRow[1] = "";

                apiData.forEach((_, branchIndex) => {
                    const colOffset = 2 + (branchIndex * 8);

                    const sumFormula = (col) => {
                        const ranges = [];
                        let start = null;

                        rowsToInclude.sort((a,b) => a-b).forEach(row => {
                            if (start === null) start = row;
                            if (!rowsToInclude.includes(row + 1)) {
                                ranges.push(`${getCol(col)}${start}:${getCol(col)}${row}`);
                                start = null;
                            }
                        });

                        return ranges.length > 0 ? `SUM(${ranges.join(',')})` : '0';
                    };

                    totalsRow[colOffset] = { formula: sumFormula(colOffset) };
                    totalsRow[colOffset + 1] = { formula: sumFormula(colOffset + 1) };
                    totalsRow[colOffset + 2] = { formula: sumFormula(colOffset + 2) };
                    totalsRow[colOffset + 3] = { formula: sumFormula(colOffset + 3) };
                    totalsRow[colOffset + 4] = {
                        formula: `${getCol(colOffset)}${currentRow}+${getCol(colOffset + 2)}${currentRow}`
                    };
                    totalsRow[colOffset + 5] = {
                        formula: `${getCol(colOffset + 2)}${currentRow}/${getCol(colOffset + 4)}${currentRow}`,
                        style: { numFmt: '0.00%' }
                    };
                    totalsRow[colOffset + 6] = {
                        formula: `${getCol(colOffset + 1)}${currentRow}+${getCol(colOffset + 3)}${currentRow}`
                    };
                    totalsRow[colOffset + 7] = {
                        formula: `${getCol(colOffset + 3)}${currentRow}/${getCol(colOffset + 6)}${currentRow}`,
                        style: { numFmt: '0.00%' }
                    };
                });

                const totalsDataRow = sheet.addRow(totalsRow);
                sheet.mergeCells(`A${currentRow}:B${currentRow}`);

                const grandTotalRow = sheet.getRow(currentRow);
                rBorder(totalsDataRow, apiData.length);

                grandTotalRow.eachCell(cell => {
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '00B050' } };
                    cell.font = { bold: true, color: { argb: 'FFFFFF' } };
                });

                currentRow++;
                addCustomerCountAndShares(sheet, apiData, currentRow, allColumns.length);
            }
        }
        if(loginPlaceId==="1"){
            const password = protectSheetWithRandomPassword(sheet,12);
          }

        addSplitSheets(workbook, apiData, branch => branch.branchName, loginPlaceId);

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), fileName);

    } catch (error) {
        console.error('Error generating Excel file:', error);
        throw error;
    }
}


export async function exportExcelDistrictWise({
                                                apiData,
                                                fileName = "District And Branch Deposits District Wise Excel.xlsx"
                                            }) {
    try {
        const workbook = new ExcelJS.Workbook();
        workbook.creator = 'MIS System';
        workbook.lastModifiedBy = 'MIS Reporting tool';
        workbook.created = new Date();
        workbook.modified = new Date();
        workbook.properties = { date1904: false };
        workbook.calcProperties.fullCalcOnLoad = true;

        const sheet = workbook.addWorksheet("Report", {
            views: [{
                state: 'frozen',
                xSplit: 2,
                ySplit: 4,
                topLeftCell: 'C5',
                activeCell: 'C5'
            }]
        });

        const baseColumns = [
            { key: 'product', width: 30 },
            { key: 'description', width: 15 }
        ];

        const branchColumnsTemplate = [
            { key: 'activeAccount', width: 12 },
            { key: 'activeAmount', width: 15, style: { numFmt: '#,##0.00' }},
            { key: 'dormantAccount', width: 12 },
            { key: 'dormantAmount', width: 15, style: { numFmt: '#,##0.00' }},
            { key: 'totalAccount', width: 12 },
            { key: 'percentage', width: 12, style: { numFmt: '0.00%' }},
            { key: 'totalAmount', width: 15, style: { numFmt: '#,##0.00' }},
            { key: 'amountPercentage', width: 12, style: { numFmt: '0.00%' }}
        ];

        const allColumns = [...baseColumns];
        apiData.forEach((_, index) => {
            branchColumnsTemplate.forEach(col => {
                allColumns.push({
                    ...col,
                    key: `${col.key}_${index}`
                });
            });
        });
        sheet.columns = allColumns;

        apiData.forEach((branch, branchIndex) => {
            const startCol = 3 + (branchIndex * 8);

            sheet.getRow(1).getCell(startCol).value = `${branch.data.branchCount[0].locationName} - Branch Count: ${branch.data.branchCount[0].branchCount}`;

            sheet.mergeCells(1, startCol, 1, startCol + 7);

            sheet.getRow(2).getCell(startCol).value = "Active";
            sheet.mergeCells(2, startCol, 2, startCol + 1);
            sheet.getRow(2).getCell(startCol + 2).value = "Dormant";
            sheet.mergeCells(2, startCol + 2, 2, startCol + 3);
            sheet.getRow(2).getCell(startCol + 4).value = "Total";
            sheet.getRow(2).getCell(startCol + 5).value = "Percentage";
            sheet.getRow(2).getCell(startCol + 6).value = "Total Amount";
            sheet.getRow(2).getCell(startCol + 7).value = "Percentage";

            sheet.getRow(3).getCell(startCol).value = "Account";
            sheet.getRow(3).getCell(startCol + 1).value = "Amount";
            sheet.getRow(3).getCell(startCol + 2).value = "Account";
            sheet.getRow(3).getCell(startCol + 3).value = "Amount";
            sheet.getRow(3).getCell(startCol + 4).value = "Account";
            sheet.getRow(3).getCell(startCol + 5).value = "(5/7)";
            sheet.getRow(3).getCell(startCol + 6).value = "";
            sheet.getRow(3).getCell(startCol + 7).value = "(6/9)";

            sheet.getRow(4).getCell(startCol).value = "3";
            sheet.getRow(4).getCell(startCol + 1).value = "4";
            sheet.getRow(4).getCell(startCol + 2).value = "5";
            sheet.getRow(4).getCell(startCol + 3).value = "6";
            sheet.getRow(4).getCell(startCol + 4).value = "7";
            sheet.getRow(4).getCell(startCol + 5).value = "8";
            sheet.getRow(4).getCell(startCol + 6).value = "9";
            sheet.getRow(4).getCell(startCol + 7).value = "10";
        });

        sheet.getRow(3).getCell(1).value = "Product Name";
        sheet.getRow(3).getCell(2).value = "Description";
        sheet.getRow(4).getCell(1).value = "1";
        sheet.getRow(4).getCell(2).value = "2";

        const grayHeaderStyle = {
            fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } },
            font: { bold: true, color: { argb: 'FF000000' }, name: 'Calibri', size: 11 },
            alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
            border: {
                top: { style: 'thin', color: { argb: 'FF000000' } },
                left: { style: 'thin', color: { argb: 'FF000000' } },
                bottom: { style: 'thin', color: { argb: 'FF000000' } },
                right: { style: 'thin', color: { argb: 'FF000000' } }
            }
        };

        const numberHeaderStyle = {
            ...grayHeaderStyle,
            font: { ...grayHeaderStyle.font, color: { argb: 'FF0000FF' } }
        };

        for (let rowNum = 1; rowNum <= 4; rowNum++) {
            const row = sheet.getRow(rowNum);
            row.eachCell(cell => {
                Object.assign(cell.style, rowNum === 4 ? numberHeaderStyle : grayHeaderStyle);
            });

            apiData.forEach((_, branchIndex) => {
                const lastCol = 3 + (branchIndex * 8) + 7;
                const cell = row.getCell(lastCol);

                cell.border = {
                    ...cell.border,
                    right: { style: 'thin', color: { argb: 'FFFF0000' } }
                };
            });
        }

        const allProducts = new Set();
        apiData.forEach(branch => {
            ['ShareAndMember', 'OtherAccounts', 'NonDormantAccounts'].forEach(type => {
                branch.data[type]?.forEach(item => {
                    if (item?.productName) {
                        allProducts.add(item.productName.trim());
                    }
                });
            });
        });

        let currentRow = 5;
        const dataRows = [];
        const subtotalRows = [];

        Array.from(allProducts).forEach(productName => {
            const hasGenderData = apiData.some(branch =>
                branch.data.ShareAndMember?.some(item => item?.productName?.trim() === productName)
            );

            if (hasGenderData) {
                const femaleRow = new Array(allColumns.length).fill('');
                femaleRow[0] = productName;
                femaleRow[1] = 'Female';

                apiData.forEach((branch, branchIndex) => {
                    const item = branch.data.ShareAndMember?.find(i => i?.productName?.trim() === productName);
                    if (item) {
                        const colOffset = 2 + (branchIndex * 8);
                        femaleRow[colOffset] = item.femaleActiveCount;
                        femaleRow[colOffset + 1] = item.femaleActiveAmount;
                        femaleRow[colOffset + 2] = item.femaleDormantCount;
                        femaleRow[colOffset + 3] = item.femaleDormantAmount;
                        femaleRow[colOffset + 4] = {
                            formula: `${getCol(colOffset)}${currentRow}+${getCol(colOffset + 2)}${currentRow}`
                        };
                        femaleRow[colOffset + 5] = {
                            formula: `${getCol(colOffset + 2)}${currentRow}/${getCol(colOffset + 4)}${currentRow}`,
                            style: { numFmt: '0.00%' }
                        };
                        femaleRow[colOffset + 6] = {
                            formula: `${getCol(colOffset + 1)}${currentRow}+${getCol(colOffset + 3)}${currentRow}`
                        };
                        femaleRow[colOffset + 7] = {
                            formula: `${getCol(colOffset + 3)}${currentRow}/${getCol(colOffset + 6)}${currentRow}`,
                            style: { numFmt: '0.00%' }
                        };
                    }
                });

                const addedFemaleRow = sheet.addRow(femaleRow);
                dataRows.push(currentRow);
                rBorder(addedFemaleRow, apiData.length);
                currentRow++;

                const maleRow = new Array(allColumns.length).fill('');
                maleRow[1] = 'Male';

                apiData.forEach((branch, branchIndex) => {
                    const item = branch.data.ShareAndMember?.find(i => i?.productName?.trim() === productName);
                    if (item) {
                        const colOffset = 2 + (branchIndex * 8);
                        maleRow[colOffset] = item.maleActiveCount;
                        maleRow[colOffset + 1] = item.maleActiveAmount;
                        maleRow[colOffset + 2] = item.maleDormantCount;
                        maleRow[colOffset + 3] = item.maleDormantAmount;
                        maleRow[colOffset + 4] = {
                            formula: `${getCol(colOffset)}${currentRow}+${getCol(colOffset + 2)}${currentRow}`
                        };
                        maleRow[colOffset + 5] = {
                            formula: `${getCol(colOffset + 2)}${currentRow}/${getCol(colOffset + 4)}${currentRow}`,
                            style: { numFmt: '0.00%' }
                        };
                        maleRow[colOffset + 6] = {
                            formula: `${getCol(colOffset + 1)}${currentRow}+${getCol(colOffset + 3)}${currentRow}`
                        };
                        maleRow[colOffset + 7] = {
                            formula: `${getCol(colOffset + 3)}${currentRow}/${getCol(colOffset + 6)}${currentRow}`,
                            style: { numFmt: '0.00%' }
                        };
                    }
                });

                const addedMaleRow = sheet.addRow(maleRow);
                dataRows.push(currentRow);
                rBorder(addedMaleRow, apiData.length);
                currentRow++;

                const subtotalRow = tRow(sheet, currentRow - 2, currentRow - 1, "Total", "B", apiData.length);
                subtotalRows.push(subtotalRow);
                currentRow++;

                SRow(sheet, currentRow, allColumns.length, apiData.length);
                currentRow++;
            }
            else {
                const dataRow = new Array(allColumns.length).fill('');
                dataRow[0] = productName;

                apiData.forEach((branch, branchIndex) => {
                    const colOffset = 2 + (branchIndex * 8);

                    let item = branch.data.OtherAccounts?.find(i => i?.productName?.trim() === productName);
                    let isNonDormant = false;

                    if (!item) {
                        item = branch.data.NonDormantAccounts?.find(i => i?.productName?.trim() === productName);
                        isNonDormant = true;
                    }

                    if (item) {
                        dataRow[colOffset] = isNonDormant ? item.count : item.activeCount;
                        dataRow[colOffset + 1] = isNonDormant ? item.totalAmount : item.activeAmount;
                        dataRow[colOffset + 2] = isNonDormant ? 0 : item.dormantCount;
                        dataRow[colOffset + 3] = isNonDormant ? 0 : item.dormantAmount;
                        dataRow[colOffset + 4] = {
                            formula: `${getCol(colOffset)}${currentRow}+${getCol(colOffset + 2)}${currentRow}`
                        };
                        dataRow[colOffset + 5] = {
                            formula: `${getCol(colOffset + 2)}${currentRow}/${getCol(colOffset + 4)}${currentRow}`,
                            style: { numFmt: '0.00%' }
                        };
                        dataRow[colOffset + 6] = {
                            formula: `${getCol(colOffset + 1)}${currentRow}+${getCol(colOffset + 3)}${currentRow}`
                        };
                        dataRow[colOffset + 7] = {
                            formula: `${getCol(colOffset + 3)}${currentRow}/${getCol(colOffset + 6)}${currentRow}`,
                            style: { numFmt: '0.00%' }
                        };
                    }
                });

                const dataSetRow = sheet.addRow(dataRow);
                sheet.mergeCells(`A${currentRow}:B${currentRow}`);
                dataRows.push(currentRow);
                rBorder(dataSetRow, apiData.length);
                currentRow++;

                SRow(sheet, currentRow, allColumns.length, apiData.length);
                currentRow++;
            }
        });

        if (dataRows.length > 0) {
            const rowsToInclude = dataRows.filter(row => !subtotalRows.includes(row));

            if (rowsToInclude.length > 0) {
                const firstDataRow = Math.min(...rowsToInclude);
                const lastDataRow = Math.max(...rowsToInclude);

                const totalsRow = [];
                totalsRow[0] = "FULL TOTAL";
                totalsRow[1] = "";

                apiData.forEach((_, branchIndex) => {
                    const colOffset = 2 + (branchIndex * 8);

                    const sumFormula = (col) => {
                        const ranges = [];
                        let start = null;

                        rowsToInclude.sort((a,b) => a-b).forEach(row => {
                            if (start === null) start = row;
                            if (!rowsToInclude.includes(row + 1)) {
                                ranges.push(`${getCol(col)}${start}:${getCol(col)}${row}`);
                                start = null;
                            }
                        });

                        return ranges.length > 0 ? `SUM(${ranges.join(',')})` : '0';
                    };

                    totalsRow[colOffset] = { formula: sumFormula(colOffset) };
                    totalsRow[colOffset + 1] = { formula: sumFormula(colOffset + 1) };
                    totalsRow[colOffset + 2] = { formula: sumFormula(colOffset + 2) };
                    totalsRow[colOffset + 3] = { formula: sumFormula(colOffset + 3) };
                    totalsRow[colOffset + 4] = {
                        formula: `${getCol(colOffset)}${currentRow}+${getCol(colOffset + 2)}${currentRow}`
                    };
                    totalsRow[colOffset + 5] = {
                        formula: `${getCol(colOffset + 2)}${currentRow}/${getCol(colOffset + 4)}${currentRow}`,
                        style: { numFmt: '0.00%' }
                    };
                    totalsRow[colOffset + 6] = {
                        formula: `${getCol(colOffset + 1)}${currentRow}+${getCol(colOffset + 3)}${currentRow}`
                    };
                    totalsRow[colOffset + 7] = {
                        formula: `${getCol(colOffset + 3)}${currentRow}/${getCol(colOffset + 6)}${currentRow}`,
                        style: { numFmt: '0.00%' }
                    };
                });

                const totalsDataRow = sheet.addRow(totalsRow);
                sheet.mergeCells(`A${currentRow}:B${currentRow}`);

                const grandTotalRow = sheet.getRow(currentRow);
                rBorder(totalsDataRow, apiData.length);

                grandTotalRow.eachCell(cell => {
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '00B050' } };
                    cell.font = { bold: true, color: { argb: 'FFFFFF' } };
                });

                currentRow++;
                addCustomerCountAndShares(sheet, apiData, currentRow, allColumns.length);
            }
        }

        addSplitSheets(workbook, apiData, locationTitle);

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), fileName);

    } catch (error) {
        console.error('Error generating Excel file:', error);
        throw error;
    }
}


export async function exportExcelDivisionalWise({
                                                  apiData,
                                                  fileName = "District And Branch Deposits Divisional Wise Excel.xlsx"
                                              }) {
    try {
        const workbook = new ExcelJS.Workbook();
        workbook.creator = 'MIS System';
        workbook.lastModifiedBy = 'MIS Reporting tool';
        workbook.created = new Date();
        workbook.modified = new Date();
        workbook.properties = { date1904: false };
        workbook.calcProperties.fullCalcOnLoad = true;

        const sheet = workbook.addWorksheet("Report", {
            views: [{
                state: 'frozen',
                xSplit: 2,
                ySplit: 4,
                topLeftCell: 'C5',
                activeCell: 'C5'
            }]
        });

        const baseColumns = [
            { key: 'product', width: 30 },
            { key: 'description', width: 15 }
        ];

        const branchColumnsTemplate = [
            { key: 'activeAccount', width: 12 },
            { key: 'activeAmount', width: 15, style: { numFmt: '#,##0.00' }},
            { key: 'dormantAccount', width: 12 },
            { key: 'dormantAmount', width: 15, style: { numFmt: '#,##0.00' }},
            { key: 'totalAccount', width: 12 },
            { key: 'percentage', width: 12, style: { numFmt: '0.00%' }},
            { key: 'totalAmount', width: 15, style: { numFmt: '#,##0.00' }},
            { key: 'amountPercentage', width: 12, style: { numFmt: '0.00%' }}
        ];

        const allColumns = [...baseColumns];
        apiData.forEach((_, index) => {
            branchColumnsTemplate.forEach(col => {
                allColumns.push({
                    ...col,
                    key: `${col.key}_${index}`
                });
            });
        });
        sheet.columns = allColumns;

        apiData.forEach((branch, branchIndex) => {
            const startCol = 3 + (branchIndex * 8);

            sheet.getRow(1).getCell(startCol).value = `${branch.data.branchCount[0].locationName} - Branch Count: ${branch.data.branchCount[0].branchCount}`;

            sheet.mergeCells(1, startCol, 1, startCol + 7);

            sheet.getRow(2).getCell(startCol).value = "Active";
            sheet.mergeCells(2, startCol, 2, startCol + 1);
            sheet.getRow(2).getCell(startCol + 2).value = "Dormant";
            sheet.mergeCells(2, startCol + 2, 2, startCol + 3);
            sheet.getRow(2).getCell(startCol + 4).value = "Total";
            sheet.getRow(2).getCell(startCol + 5).value = "Percentage";
            sheet.getRow(2).getCell(startCol + 6).value = "Total Amount";
            sheet.getRow(2).getCell(startCol + 7).value = "Percentage";

            sheet.getRow(3).getCell(startCol).value = "Account";
            sheet.getRow(3).getCell(startCol + 1).value = "Amount";
            sheet.getRow(3).getCell(startCol + 2).value = "Account";
            sheet.getRow(3).getCell(startCol + 3).value = "Amount";
            sheet.getRow(3).getCell(startCol + 4).value = "Account";
            sheet.getRow(3).getCell(startCol + 5).value = "(5/7)";
            sheet.getRow(3).getCell(startCol + 6).value = "";
            sheet.getRow(3).getCell(startCol + 7).value = "(6/9)";

            sheet.getRow(4).getCell(startCol).value = "3";
            sheet.getRow(4).getCell(startCol + 1).value = "4";
            sheet.getRow(4).getCell(startCol + 2).value = "5";
            sheet.getRow(4).getCell(startCol + 3).value = "6";
            sheet.getRow(4).getCell(startCol + 4).value = "7";
            sheet.getRow(4).getCell(startCol + 5).value = "8";
            sheet.getRow(4).getCell(startCol + 6).value = "9";
            sheet.getRow(4).getCell(startCol + 7).value = "10";
        });

        sheet.getRow(3).getCell(1).value = "Product Name";
        sheet.getRow(3).getCell(2).value = "Description";
        sheet.getRow(4).getCell(1).value = "1";
        sheet.getRow(4).getCell(2).value = "2";

        const grayHeaderStyle = {
            fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } },
            font: { bold: true, color: { argb: 'FF000000' }, name: 'Calibri', size: 11 },
            alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
            border: {
                top: { style: 'thin', color: { argb: 'FF000000' } },
                left: { style: 'thin', color: { argb: 'FF000000' } },
                bottom: { style: 'thin', color: { argb: 'FF000000' } },
                right: { style: 'thin', color: { argb: 'FF000000' } }
            }
        };

        const numberHeaderStyle = {
            ...grayHeaderStyle,
            font: { ...grayHeaderStyle.font, color: { argb: 'FF0000FF' } }
        };

        for (let rowNum = 1; rowNum <= 4; rowNum++) {
            const row = sheet.getRow(rowNum);
            row.eachCell(cell => {
                Object.assign(cell.style, rowNum === 4 ? numberHeaderStyle : grayHeaderStyle);
            });

            apiData.forEach((_, branchIndex) => {
                const lastCol = 3 + (branchIndex * 8) + 7;
                const cell = row.getCell(lastCol);

                cell.border = {
                    ...cell.border,
                    right: { style: 'thin', color: { argb: 'FFFF0000' } }
                };
            });
        }

        const allProducts = new Set();
        apiData.forEach(branch => {
            ['ShareAndMember', 'OtherAccounts', 'NonDormantAccounts'].forEach(type => {
                branch.data[type]?.forEach(item => {
                    if (item?.productName) {
                        allProducts.add(item.productName.trim());
                    }
                });
            });
        });

        let currentRow = 5;
        const dataRows = [];
        const subtotalRows = [];

        Array.from(allProducts).forEach(productName => {
            const hasGenderData = apiData.some(branch =>
                branch.data.ShareAndMember?.some(item => item?.productName?.trim() === productName)
            );

            if (hasGenderData) {
                const femaleRow = new Array(allColumns.length).fill('');
                femaleRow[0] = productName;
                femaleRow[1] = 'Female';

                apiData.forEach((branch, branchIndex) => {
                    const item = branch.data.ShareAndMember?.find(i => i?.productName?.trim() === productName);
                    if (item) {
                        const colOffset = 2 + (branchIndex * 8);
                        femaleRow[colOffset] = item.femaleActiveCount;
                        femaleRow[colOffset + 1] = item.femaleActiveAmount;
                        femaleRow[colOffset + 2] = item.femaleDormantCount;
                        femaleRow[colOffset + 3] = item.femaleDormantAmount;
                        femaleRow[colOffset + 4] = {
                            formula: `${getCol(colOffset)}${currentRow}+${getCol(colOffset + 2)}${currentRow}`
                        };
                        femaleRow[colOffset + 5] = {
                            formula: `${getCol(colOffset + 2)}${currentRow}/${getCol(colOffset + 4)}${currentRow}`,
                            style: { numFmt: '0.00%' }
                        };
                        femaleRow[colOffset + 6] = {
                            formula: `${getCol(colOffset + 1)}${currentRow}+${getCol(colOffset + 3)}${currentRow}`
                        };
                        femaleRow[colOffset + 7] = {
                            formula: `${getCol(colOffset + 3)}${currentRow}/${getCol(colOffset + 6)}${currentRow}`,
                            style: { numFmt: '0.00%' }
                        };
                    }
                });

                const addedFemaleRow = sheet.addRow(femaleRow);
                dataRows.push(currentRow);
                rBorder(addedFemaleRow, apiData.length);
                currentRow++;

                const maleRow = new Array(allColumns.length).fill('');
                maleRow[1] = 'Male';

                apiData.forEach((branch, branchIndex) => {
                    const item = branch.data.ShareAndMember?.find(i => i?.productName?.trim() === productName);
                    if (item) {
                        const colOffset = 2 + (branchIndex * 8);
                        maleRow[colOffset] = item.maleActiveCount;
                        maleRow[colOffset + 1] = item.maleActiveAmount;
                        maleRow[colOffset + 2] = item.maleDormantCount;
                        maleRow[colOffset + 3] = item.maleDormantAmount;
                        maleRow[colOffset + 4] = {
                            formula: `${getCol(colOffset)}${currentRow}+${getCol(colOffset + 2)}${currentRow}`
                        };
                        maleRow[colOffset + 5] = {
                            formula: `${getCol(colOffset + 2)}${currentRow}/${getCol(colOffset + 4)}${currentRow}`,
                            style: { numFmt: '0.00%' }
                        };
                        maleRow[colOffset + 6] = {
                            formula: `${getCol(colOffset + 1)}${currentRow}+${getCol(colOffset + 3)}${currentRow}`
                        };
                        maleRow[colOffset + 7] = {
                            formula: `${getCol(colOffset + 3)}${currentRow}/${getCol(colOffset + 6)}${currentRow}`,
                            style: { numFmt: '0.00%' }
                        };
                    }
                });

                const addedMaleRow = sheet.addRow(maleRow);
                dataRows.push(currentRow);
                rBorder(addedMaleRow, apiData.length);
                currentRow++;

                const subtotalRow = tRow(sheet, currentRow - 2, currentRow - 1, "Total", "B", apiData.length);
                subtotalRows.push(subtotalRow);
                currentRow++;

                SRow(sheet, currentRow, allColumns.length, apiData.length);
                currentRow++;
            }
            else {
                const dataRow = new Array(allColumns.length).fill('');
                dataRow[0] = productName;

                apiData.forEach((branch, branchIndex) => {
                    const colOffset = 2 + (branchIndex * 8);

                    let item = branch.data.OtherAccounts?.find(i => i?.productName?.trim() === productName);
                    let isNonDormant = false;

                    if (!item) {
                        item = branch.data.NonDormantAccounts?.find(i => i?.productName?.trim() === productName);
                        isNonDormant = true;
                    }

                    if (item) {
                        dataRow[colOffset] = isNonDormant ? item.count : item.activeCount;
                        dataRow[colOffset + 1] = isNonDormant ? item.totalAmount : item.activeAmount;
                        dataRow[colOffset + 2] = isNonDormant ? 0 : item.dormantCount;
                        dataRow[colOffset + 3] = isNonDormant ? 0 : item.dormantAmount;
                        dataRow[colOffset + 4] = {
                            formula: `${getCol(colOffset)}${currentRow}+${getCol(colOffset + 2)}${currentRow}`
                        };
                        dataRow[colOffset + 5] = {
                            formula: `${getCol(colOffset + 2)}${currentRow}/${getCol(colOffset + 4)}${currentRow}`,
                            style: { numFmt: '0.00%' }
                        };
                        dataRow[colOffset + 6] = {
                            formula: `${getCol(colOffset + 1)}${currentRow}+${getCol(colOffset + 3)}${currentRow}`
                        };
                        dataRow[colOffset + 7] = {
                            formula: `${getCol(colOffset + 3)}${currentRow}/${getCol(colOffset + 6)}${currentRow}`,
                            style: { numFmt: '0.00%' }
                        };
                    }
                });

                const dataSetRow = sheet.addRow(dataRow);
                sheet.mergeCells(`A${currentRow}:B${currentRow}`);
                dataRows.push(currentRow);
                rBorder(dataSetRow, apiData.length);
                currentRow++;

                SRow(sheet, currentRow, allColumns.length, apiData.length);
                currentRow++;
            }
        });

        if (dataRows.length > 0) {
            const rowsToInclude = dataRows.filter(row => !subtotalRows.includes(row));

            if (rowsToInclude.length > 0) {
                const firstDataRow = Math.min(...rowsToInclude);
                const lastDataRow = Math.max(...rowsToInclude);

                const totalsRow = [];
                totalsRow[0] = "FULL TOTAL";
                totalsRow[1] = "";

                apiData.forEach((_, branchIndex) => {
                    const colOffset = 2 + (branchIndex * 8);

                    const sumFormula = (col) => {
                        const ranges = [];
                        let start = null;

                        rowsToInclude.sort((a,b) => a-b).forEach(row => {
                            if (start === null) start = row;
                            if (!rowsToInclude.includes(row + 1)) {
                                ranges.push(`${getCol(col)}${start}:${getCol(col)}${row}`);
                                start = null;
                            }
                        });

                        return ranges.length > 0 ? `SUM(${ranges.join(',')})` : '0';
                    };

                    totalsRow[colOffset] = { formula: sumFormula(colOffset) };
                    totalsRow[colOffset + 1] = { formula: sumFormula(colOffset + 1) };
                    totalsRow[colOffset + 2] = { formula: sumFormula(colOffset + 2) };
                    totalsRow[colOffset + 3] = { formula: sumFormula(colOffset + 3) };
                    totalsRow[colOffset + 4] = {
                        formula: `${getCol(colOffset)}${currentRow}+${getCol(colOffset + 2)}${currentRow}`
                    };
                    totalsRow[colOffset + 5] = {
                        formula: `${getCol(colOffset + 2)}${currentRow}/${getCol(colOffset + 4)}${currentRow}`,
                        style: { numFmt: '0.00%' }
                    };
                    totalsRow[colOffset + 6] = {
                        formula: `${getCol(colOffset + 1)}${currentRow}+${getCol(colOffset + 3)}${currentRow}`
                    };
                    totalsRow[colOffset + 7] = {
                        formula: `${getCol(colOffset + 3)}${currentRow}/${getCol(colOffset + 6)}${currentRow}`,
                        style: { numFmt: '0.00%' }
                    };
                });

                const totalsDataRow = sheet.addRow(totalsRow);
                sheet.mergeCells(`A${currentRow}:B${currentRow}`);

                const grandTotalRow = sheet.getRow(currentRow);
                rBorder(totalsDataRow, apiData.length);

                grandTotalRow.eachCell(cell => {
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '00B050' } };
                    cell.font = { bold: true, color: { argb: 'FFFFFF' } };
                });

                currentRow++;
                addCustomerCountAndShares(sheet, apiData, currentRow, allColumns.length);
            }
        }

        addSplitSheets(workbook, apiData, locationTitle);

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), fileName);

    } catch (error) {
        console.error('Error generating Excel file:', error);
        throw error;
    }
}




function addCustomerCountAndShares(sheet, apiData, startRow, totalColumns, groupSize = 8) {
    let currentRow = startRow;
    SRow(sheet, currentRow, totalColumns, apiData.length, groupSize);
    currentRow++;
    const customerCountRow1 = new Array(totalColumns).fill('');
    customerCountRow1[0] = "Customer Count";

    customerCountRow1[1] = "Female";

    apiData.forEach((branch, branchIndex) => {
        const colOffset = 2 + (branchIndex * groupSize);
        const customerData = branch.data.customerCount?.[0];
        if (customerData) {
            customerCountRow1[colOffset] = customerData.femaleCount;
        }
    });

    sheet.addRow(customerCountRow1);

    rBorder(sheet.getRow(currentRow), apiData.length, groupSize);
    currentRow++;

    const customerCountRow2 = new Array(totalColumns).fill('');
    customerCountRow2[1] = "Male";

    apiData.forEach((branch, branchIndex) => {
        const colOffset = 2 + (branchIndex * groupSize);
        const customerData = branch.data.customerCount?.[0];
        if (customerData) {
            customerCountRow2[colOffset] = customerData.maleCount;
        }
    });

    sheet.addRow(customerCountRow2);

    rBorder(sheet.getRow(currentRow), apiData.length, groupSize);
    currentRow++;

    const customerCountRow3 = new Array(totalColumns).fill('');
    customerCountRow3[1] = "Total";

    apiData.forEach((branch, branchIndex) => {
        const colOffset = 2 + (branchIndex * groupSize);
        const customerData = branch.data.customerCount?.[0];
        if (customerData) {
            customerCountRow3[colOffset] = customerData.totalCount;
        }
    });

    sheet.addRow(customerCountRow3);
    rBorder(sheet.getRow(currentRow), apiData.length, groupSize);
    currentRow++;
    SRow(sheet, currentRow, totalColumns, apiData.length, groupSize);
    currentRow++;
    const sharesRow1 = new Array(totalColumns).fill('');
    sharesRow1[1] = "Female";

    apiData.forEach((branch, branchIndex) => {
        const colOffset = 2 + (branchIndex * groupSize);
        const shareData = branch.data.shareValues?.[0];
        if (shareData) {
            sharesRow1[colOffset] = shareData.femaleCount;
            sharesRow1[colOffset + 1] = shareData.femaleAmount;
        }
    });

    sheet.addRow(sharesRow1);
    sheet.getCell(`A${currentRow}`).value = "Number Of Completed 500 Shares";
    sheet.getCell(`A${currentRow}`).alignment = { wrapText: true };
    rBorder(sheet.getRow(currentRow), apiData.length, groupSize);
    currentRow++;

    const sharesRow2 = new Array(totalColumns).fill('');
    sharesRow2[1] = "Male";

    apiData.forEach((branch, branchIndex) => {
        const colOffset = 2 + (branchIndex * groupSize);
        const shareData = branch.data.shareValues?.[0];
        if (shareData) {
            sharesRow2[colOffset] = shareData.maleCount;
            sharesRow2[colOffset + 1] = shareData.maleAmount;
        }
    });

    sheet.addRow(sharesRow2);
    rBorder(sheet.getRow(currentRow), apiData.length, groupSize);
    currentRow++;

    const sharesRow3 = new Array(totalColumns).fill('');
    sharesRow3[1] = "Total";

    apiData.forEach((branch, branchIndex) => {
        const colOffset = 2 + (branchIndex * groupSize);
        const shareData = branch.data.shareValues?.[0];
        if (shareData) {
            sharesRow3[colOffset] = {
                formula: `${getCol(colOffset)}${currentRow - 2}+${getCol(colOffset)}${currentRow - 1}`
            };
            sharesRow3[colOffset + 1] = {
                formula: `${getCol(colOffset + 1)}${currentRow - 2}+${getCol(colOffset + 1)}${currentRow - 1}`
            };
        }
    });

    sheet.addRow(sharesRow3);
    rBorder(sheet.getRow(currentRow), apiData.length, groupSize);
    currentRow++;
    SRow(sheet, currentRow, totalColumns, apiData.length, groupSize);
}

function rBorder(row, branchCount, groupSize = 8) {
    for (let i = 0; i < branchCount; i++) {
        const borderCellIndex = 3 + (i * groupSize) + (groupSize - 1);
        const cell = row.getCell(borderCellIndex);

        cell.border = {
            top: { style: 'thin', color: { argb: 'FFD3D3D3' } },
            left: { style: 'thin', color: { argb: 'FFD3D3D3' } },
            bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } },
            right: { style: 'thin', color: { argb: 'FFFF0000' } }
        };
    }
}

function tRow(sheet, startRow, endRow, label, labelColumn = 'B', apiDataLength) {
    const rowNum = endRow + 1;
    const totalRow = new Array(sheet.columnCount).fill('');
    totalRow[labelColumn - 1] = label;

    const branchCount = (sheet.columnCount - 2) / 8;

    for (let branchIndex = 0; branchIndex < branchCount; branchIndex++) {
        const colOffset = 2 + (branchIndex * 8);
        totalRow[colOffset] = {
            formula: `${getCol(colOffset)}${startRow}+${getCol(colOffset)}${endRow}`
        };
        totalRow[colOffset + 1] = {
            formula: `${getCol(colOffset + 1)}${startRow}+${getCol(colOffset + 1)}${endRow}`
        };
        totalRow[colOffset + 2] = {
            formula: `${getCol(colOffset + 2)}${startRow}+${getCol(colOffset + 2)}${endRow}`
        };
        totalRow[colOffset + 3] = {
            formula: `${getCol(colOffset + 3)}${startRow}+${getCol(colOffset + 3)}${endRow}`
        };
        totalRow[colOffset + 4] = {
            formula: `${getCol(colOffset)}${rowNum}+${getCol(colOffset + 2)}${rowNum}`
        };
        totalRow[colOffset + 5] = {
            formula: `${getCol(colOffset + 2)}${rowNum}/${getCol(colOffset + 4)}${rowNum}`,
            style: { numFmt: '0.00%' }
        };
        totalRow[colOffset + 6] = {
            formula: `${getCol(colOffset + 1)}${rowNum}+${getCol(colOffset + 3)}${rowNum}`
        };
        totalRow[colOffset + 7] = {
            formula: `${getCol(colOffset + 3)}${rowNum}/${getCol(colOffset + 6)}${rowNum}`,
            style: { numFmt: '0.00%' }
        };
    }

    const totalAddRow = sheet.addRow(totalRow);
    rBorder(totalAddRow, apiDataLength);

    const row = sheet.getRow(rowNum);
    row.eachCell(cell => {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '92D050' } };
        cell.font = { bold: true };
    });

    return rowNum;
}

const getCol = (colNum) => {
    let column = '';
    while (colNum >= 0) {
        column = String.fromCharCode(65 + (colNum % 26)) + column;
        colNum = Math.floor(colNum / 26) - 1;
    }
    return column;
};

function SRow(sheet, rowNum, colCount, apiDataLength, groupSize = 8) {
    const spacerRow = new Array(colCount).fill('');
    const addedRow = sheet.addRow(spacerRow);

    addedRow.eachCell(cell => {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFE0E0E0' }
        };
        cell.border = null;
    });

    rBorder(addedRow, apiDataLength, groupSize);

    sheet.mergeCells(`A${rowNum}:B${rowNum}`);
}

const SPLIT_GROUP_SIZE = 2;

const locationTitle = (branch) =>
    `${branch.data.branchCount[0].locationName} - Branch Count: ${branch.data.branchCount[0].branchCount}`;

function addSplitSheets(workbook, apiData, titleFn, loginPlaceId) {
    addSplitSheet(workbook, apiData, titleFn, loginPlaceId, 'active', 'Active');
    addSplitSheet(workbook, apiData, titleFn, loginPlaceId, 'dormant', 'Dormant');
}

function tRowSplit(sheet, startRow, endRow, label, apiDataLength, groupSize) {
    const rowNum = endRow + 1;
    const totalRow = new Array(sheet.columnCount).fill('');
    totalRow[1] = label;

    const branchCount = (sheet.columnCount - 2) / groupSize;

    for (let branchIndex = 0; branchIndex < branchCount; branchIndex++) {
        const colOffset = 2 + (branchIndex * groupSize);
        totalRow[colOffset] = {
            formula: `${getCol(colOffset)}${startRow}+${getCol(colOffset)}${endRow}`
        };
        totalRow[colOffset + 1] = {
            formula: `${getCol(colOffset + 1)}${startRow}+${getCol(colOffset + 1)}${endRow}`,
            style: { numFmt: '#,##0.00' }
        };
    }

    const totalAddRow = sheet.addRow(totalRow);
    rBorder(totalAddRow, apiDataLength, groupSize);

    const row = sheet.getRow(rowNum);
    row.eachCell(cell => {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '92D050' } };
        cell.font = { bold: true };
    });

    return rowNum;
}

function addSplitSheet(workbook, apiData, titleFn, loginPlaceId, mode, sheetName) {
    const groupSize = SPLIT_GROUP_SIZE;
    const isActive = mode === 'active';

    const sheet = workbook.addWorksheet(sheetName, {
        views: [{
            state: 'frozen',
            xSplit: 2,
            ySplit: 4,
            topLeftCell: 'C5',
            activeCell: 'C5'
        }]
    });

    const allColumns = [
        { key: 'product', width: 30 },
        { key: 'description', width: 15 }
    ];
    apiData.forEach((_, index) => {
        allColumns.push({ key: `account_${index}`, width: 12 });
        allColumns.push({ key: `amount_${index}`, width: 16, style: { numFmt: '#,##0.00' } });
    });
    sheet.columns = allColumns;

    const groupLabel = isActive ? 'Active' : 'Dormant';

    apiData.forEach((branch, branchIndex) => {
        const startCol = 3 + (branchIndex * groupSize);

        sheet.getRow(1).getCell(startCol).value = titleFn(branch);
        sheet.mergeCells(1, startCol, 1, startCol + groupSize - 1);

        sheet.getRow(2).getCell(startCol).value = groupLabel;
        sheet.mergeCells(2, startCol, 2, startCol + 1);

        sheet.getRow(3).getCell(startCol).value = "Account";
        sheet.getRow(3).getCell(startCol + 1).value = "Amount";

        sheet.getRow(4).getCell(startCol).value = "3";
        sheet.getRow(4).getCell(startCol + 1).value = "4";
    });

    sheet.getRow(3).getCell(1).value = "Product Name";
    sheet.getRow(3).getCell(2).value = "Description";
    sheet.getRow(4).getCell(1).value = "1";
    sheet.getRow(4).getCell(2).value = "2";

    const grayHeaderStyle = {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } },
        font: { bold: true, color: { argb: 'FF000000' }, name: 'Calibri', size: 11 },
        alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
        border: {
            top: { style: 'thin', color: { argb: 'FF000000' } },
            left: { style: 'thin', color: { argb: 'FF000000' } },
            bottom: { style: 'thin', color: { argb: 'FF000000' } },
            right: { style: 'thin', color: { argb: 'FF000000' } }
        }
    };

    const numberHeaderStyle = {
        ...grayHeaderStyle,
        font: { ...grayHeaderStyle.font, color: { argb: 'FF0000FF' } }
    };

    for (let rowNum = 1; rowNum <= 4; rowNum++) {
        const row = sheet.getRow(rowNum);
        row.eachCell(cell => {
            Object.assign(cell.style, rowNum === 4 ? numberHeaderStyle : grayHeaderStyle);
        });

        apiData.forEach((_, branchIndex) => {
            const lastCol = 3 + (branchIndex * groupSize) + (groupSize - 1);
            const cell = row.getCell(lastCol);
            cell.border = {
                ...cell.border,
                right: { style: 'thin', color: { argb: 'FFFF0000' } }
            };
        });
    }

    const valuesFor = (item, isNonDormant, gender) => {
        let activeCount, activeAmount, dormantCount, dormantAmount;

        if (isNonDormant) {
            activeCount = item.count || 0;
            activeAmount = item.totalAmount || 0;
            dormantCount = 0;
            dormantAmount = 0;
        } else if (gender) {
            activeCount = item[`${gender}ActiveCount`] || 0;
            activeAmount = item[`${gender}ActiveAmount`] || 0;
            dormantCount = item[`${gender}DormantCount`] || 0;
            dormantAmount = item[`${gender}DormantAmount`] || 0;
        } else {
            activeCount = item.activeCount || 0;
            activeAmount = item.activeAmount || 0;
            dormantCount = item.dormantCount || 0;
            dormantAmount = item.dormantAmount || 0;
        }

        return {
            account: isActive ? activeCount : dormantCount,
            amount: isActive ? activeAmount : dormantAmount
        };
    };

    const allProducts = new Set();
    apiData.forEach(branch => {
        ['ShareAndMember', 'OtherAccounts', 'NonDormantAccounts'].forEach(type => {
            branch.data[type]?.forEach(item => {
                if (item?.productName) {
                    allProducts.add(item.productName.trim());
                }
            });
        });
    });

    let currentRow = 5;
    const dataRows = [];
    const subtotalRows = [];

    Array.from(allProducts).forEach(productName => {
        const hasGenderData = apiData.some(branch =>
            branch.data.ShareAndMember?.some(item => item?.productName?.trim() === productName)
        );

        if (hasGenderData) {
            ['Female', 'Male'].forEach(gender => {
                const rowValues = new Array(allColumns.length).fill('');
                if (gender === 'Female') {
                    rowValues[0] = productName;
                }
                rowValues[1] = gender;

                apiData.forEach((branch, branchIndex) => {
                    const shareList = branch.data?.ShareAndMember || [];
                    const item = shareList.find(i => {
                        const name = (i?.productName || '').toString().trim();
                        return name === productName || name.toLowerCase() === productName.toLowerCase();
                    });
                    if (item) {
                        const colOffset = 2 + (branchIndex * groupSize);
                        let activeCount = 0, activeAmount = 0, dormantCount = 0, dormantAmount = 0;
                        if (gender === 'Female') {
                            activeCount = Number(item.femaleActiveCount || 0);
                            activeAmount = Number(item.femaleActiveAmount || 0);
                            dormantCount = Number(item.femaleDormantCount || 0);
                            dormantAmount = Number(item.femaleDormantAmount || 0);
                        } else {
                            activeCount = Number(item.maleActiveCount || 0);
                            activeAmount = Number(item.maleActiveAmount || 0);
                            dormantCount = Number(item.maleDormantCount || 0);
                            dormantAmount = Number(item.maleDormantAmount || 0);
                        }
                        const accountVal = isActive ? activeCount : dormantCount;
                        const amountVal = isActive ? activeAmount : dormantAmount;
                        if (accountVal !== 0 || amountVal !== 0 || accountVal === 0) {
                            rowValues[colOffset] = accountVal === 0 && item ? accountVal : accountVal;
                        }
                        rowValues[colOffset] = accountVal;
                        rowValues[colOffset + 1] = amountVal;
                    }
                });

                const addedRow = sheet.addRow(rowValues);
                dataRows.push(currentRow);
                rBorder(addedRow, apiData.length, groupSize);
                currentRow++;
            });

            const subtotalRow = tRowSplit(sheet, currentRow - 2, currentRow - 1, "Total", apiData.length, groupSize);
            subtotalRows.push(subtotalRow);
            currentRow++;

            SRow(sheet, currentRow, allColumns.length, apiData.length, groupSize);
            currentRow++;
        } else {
            const rowValues = new Array(allColumns.length).fill('');
            rowValues[0] = productName;

            apiData.forEach((branch, branchIndex) => {
                const colOffset = 2 + (branchIndex * groupSize);
                let item = (branch.data.OtherAccounts || []).find(i => {
                    const name = (i?.productName || '').toString().trim();
                    return name === productName || name.toLowerCase() === productName.toLowerCase();
                });
                let isNonDormant = false;
                if (!item) {
                    item = (branch.data.NonDormantAccounts || []).find(i => {
                        const name = (i?.productName || '').toString().trim();
                        return name === productName || name.toLowerCase() === productName.toLowerCase();
                    });
                    isNonDormant = true;
                }
                if (item) {
                    let activeCount = 0, activeAmount = 0, dormantCount = 0, dormantAmount = 0;
                    if (isNonDormant) {
                        activeCount = Number(item.count || 0);
                        activeAmount = Number(item.totalAmount || 0);
                        dormantCount = 0;
                        dormantAmount = 0;
                    } else {
                        activeCount = Number(item.activeCount || 0);
                        activeAmount = Number(item.activeAmount || 0);
                        dormantCount = Number(item.dormantCount || 0);
                        dormantAmount = Number(item.dormantAmount || 0);
                    }
                    rowValues[colOffset] = isActive ? activeCount : dormantCount;
                    rowValues[colOffset + 1] = isActive ? activeAmount : dormantAmount;
                }
            });

            const addedRow = sheet.addRow(rowValues);
            sheet.mergeCells(`A${currentRow}:B${currentRow}`);
            dataRows.push(currentRow);
            rBorder(addedRow, apiData.length, groupSize);
            currentRow++;

            SRow(sheet, currentRow, allColumns.length, apiData.length, groupSize);
            currentRow++;
        }
    });

    if (dataRows.length > 0) {
        const rowsToInclude = dataRows.filter(row => !subtotalRows.includes(row));
        if (rowsToInclude.length > 0) {
            const totalsRow = new Array(allColumns.length).fill('');
            totalsRow[0] = "FULL TOTAL";

            apiData.forEach((_, branchIndex) => {
                const colOffset = 2 + (branchIndex * groupSize);
                const sumFormula = (col) => {
                    const ranges = [];
                    let start = null;
                    rowsToInclude.sort((a, b) => a - b).forEach(row => {
                        if (start === null) start = row;
                        if (!rowsToInclude.includes(row + 1)) {
                            ranges.push(`${getCol(col)}${start}:${getCol(col)}${row}`);
                            start = null;
                        }
                    });
                    return ranges.length > 0 ? `SUM(${ranges.join(',')})` : '0';
                };
                totalsRow[colOffset] = { formula: sumFormula(colOffset) };
                totalsRow[colOffset + 1] = { formula: sumFormula(colOffset + 1), style: { numFmt: '#,##0.00' } };
            });

            const totalsDataRow = sheet.addRow(totalsRow);
            sheet.mergeCells(`A${currentRow}:B${currentRow}`);
            const grandTotalRow = sheet.getRow(currentRow);
            rBorder(totalsDataRow, apiData.length, groupSize);
            grandTotalRow.eachCell(cell => {
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '00B050' } };
                cell.font = { bold: true, color: { argb: 'FFFFFF' } };
            });
            currentRow++;

            addCustomerCountAndShares(sheet, apiData, currentRow, allColumns.length, groupSize);
        }
    }

    if (loginPlaceId === "1") {
        protectSheetWithRandomPassword(sheet, 12);
    }
}


